/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminAccountViewModel } from '../models/AdminAccountViewModel';
import type { CreateAdminAccountCommand } from '../models/CreateAdminAccountCommand';
import type { DeleteAdminAccountCommand } from '../models/DeleteAdminAccountCommand';
import type { GetAdminAccountByIdQuery } from '../models/GetAdminAccountByIdQuery';
import type { ListAdminAccountsQuery } from '../models/ListAdminAccountsQuery';
import type { ResendAdminAccountInvitationEmailCommand } from '../models/ResendAdminAccountInvitationEmailCommand';
import type { UpdateAdminAccountPermissionsCommand } from '../models/UpdateAdminAccountPermissionsCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminAccountsService {
    /**
     * List all admin accounts
     * @param requestBody
     * @returns AdminAccountViewModel Success
     * @throws ApiError
     */
    public static postApiAdminAccountsListAdminAccounts(
        requestBody?: ListAdminAccountsQuery,
    ): CancelablePromise<Array<AdminAccountViewModel>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin-accounts/list-admin-accounts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get admin account by ID
     * @param requestBody
     * @returns AdminAccountViewModel Success
     * @throws ApiError
     */
    public static postApiAdminAccountsGetAdminAccountById(
        requestBody?: GetAdminAccountByIdQuery,
    ): CancelablePromise<AdminAccountViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin-accounts/get-admin-account-by-id',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Record that the current admin is active in the dashboard (updates last seen)
     * @returns any Success
     * @throws ApiError
     */
    public static postApiAdminAccountsTrackActivity(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin-accounts/track-activity',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Create a new admin account
     * @param requestBody
     * @returns AdminAccountViewModel Success
     * @throws ApiError
     */
    public static postApiAdminAccountsCreateAdminAccount(
        requestBody?: CreateAdminAccountCommand,
    ): CancelablePromise<AdminAccountViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin-accounts/create-admin-account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Update admin account permissions
     * @param requestBody
     * @returns AdminAccountViewModel Success
     * @throws ApiError
     */
    public static postApiAdminAccountsUpdateAdminAccountPermissions(
        requestBody?: UpdateAdminAccountPermissionsCommand,
    ): CancelablePromise<AdminAccountViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin-accounts/update-admin-account-permissions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Delete an admin account
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiAdminAccountsDeleteAdminAccount(
        requestBody?: DeleteAdminAccountCommand,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin-accounts/delete-admin-account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Resend admin account invitation email
     * @param requestBody
     * @returns AdminAccountViewModel Success
     * @throws ApiError
     */
    public static postApiAdminAccountsResendAdminAccountInvitationEmail(
        requestBody?: ResendAdminAccountInvitationEmailCommand,
    ): CancelablePromise<AdminAccountViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin-accounts/resend-admin-account-invitation-email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
}
